/**
 * Onde a pessoa estava no kanban de cada pipeline: rolagem horizontal do
 * quadro, rolagem e páginas carregadas de cada coluna e o último negócio
 * aberto. Fica no sessionStorage (vale só nesta aba), para que abrir um card e
 * voltar — pelo X, pelo link da pipeline ou pelo botão voltar do navegador —
 * devolva o quadro no mesmo lugar.
 */
export interface ColumnPosition {
  scrollTop: number;
  pages: number;
}

export interface KanbanPosition {
  scrollLeft: number;
  columns: Record<string, ColumnPosition>;
  openedBusinessId?: string;
}

const KEY = 'crm.kanban-position';
const EMPTY: KanbanPosition = { scrollLeft: 0, columns: {} };

function readAll(): Record<string, KanbanPosition> {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Record<string, KanbanPosition>) : {};
  } catch {
    return {};
  }
}

export function readKanbanPosition(pipelineId: string): KanbanPosition {
  const saved = readAll()[pipelineId];
  return saved ? { ...EMPTY, ...saved, columns: saved.columns ?? {} } : EMPTY;
}

function write(pipelineId: string, change: (position: KanbanPosition) => KanbanPosition) {
  const all = readAll();
  all[pipelineId] = change(all[pipelineId] ?? EMPTY);
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    // navegador sem armazenamento: o quadro só não volta para o mesmo lugar
  }
}

export function saveBoardScroll(pipelineId: string, scrollLeft: number) {
  write(pipelineId, (position) => ({ ...position, scrollLeft }));
}

export function saveColumnScroll(pipelineId: string, stageId: string, column: ColumnPosition) {
  write(pipelineId, (position) => ({
    ...position,
    columns: { ...position.columns, [stageId]: column },
  }));
}

/** Sem `businessId`, esquece o card aberto (o destaque já foi mostrado). */
export function saveOpenedBusiness(pipelineId: string, businessId?: string) {
  write(pipelineId, (position) => ({ ...position, openedBusinessId: businessId }));
}
